export function scrollToElement(selector) {
    const element = document.querySelector(selector);
    if (element) {
        setTimeout(() => {
            element.scrollTop = element.scrollHeight;
        }, 100);
    }
}

export function scrollElementToBottomAndCenter(selector, bottomOffset = 0) {

    setTimeout(() => {
        const element = document.querySelector(selector);
        if (!element) return;

        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const windowHeight = window.innerHeight;

        window.scrollTo({
            top: absoluteElementTop - windowHeight + elementRect.height + bottomOffset,
        });
    }, 250);
}